import React, { useState, useEffect } from "react";
import axios from "axios";
import misionn from "../Profile/profileimage/mision.webp";
import vision from "../Profile/profileimage/mision.webp";
import { FaEdit, FaSave } from "react-icons/fa";
// import "./missionvissioncards.css"
// Styles
const containerStyle = {
    marginTop: "10px",
    border: "1px solid #bbb",
    borderRadius: "10px",
};

const cardWrapperStyle = {
    // display: "flex",
    justifyContent: "center",
    gap: "40px",
    overflowX: "auto",
    flexWrap: "nowrap",
    padding: "40px",
    borderRadius: "20px",
    border: "none"
};

const baseCardStyle = {
    backgroundColor: "#fff",
    borderRadius: "16px",
    border: "1px solid #b15cd6",
    padding: "35px 30px",
    // width: "460px",
    boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
    textAlign: "center",
    transition: "all 0.3s ease-in-out",
    cursor: "default",
    position: "relative",
};

const titleBaseStyle = {
    fontSize: "26px",
    fontWeight: "700",
    marginBottom: "14px",
};


const sectionTitleStyle = {
    textAlign: "center",
    fontSize: "36px",
    fontWeight: "800",
    color: "rgb(177 93 198)",
    letterSpacing: "0.5px",
    marginBottom: "-20px",
    marginTop: "10px",
};

const textAreaStyle = {
    width: "100%",
    padding: "10px",
    borderRadius: "8px",
    resize: "none",
    fontSize: "16px",
};

const imageStyle = {
    width: "80px",
    height: "80px",
    objectFit: "cover",
    borderRadius: "50%",
    marginBottom: "20px",
    border: "2px solid #b15dc6",
};

// ✅ Card Component
const Card = ({ image, title, value, onChange }) => {
    return (
        <div style={baseCardStyle} className="mission-vission-cards">
            <img src={image} alt={title} style={imageStyle} />
            <h3 style={titleBaseStyle}>{title}</h3>
            <textarea
                value={value}
                onChange={(e) => onChange(e.target.value)}
                rows={5}
                style={textAreaStyle}
            />
        </div>
    );
};


// Main Component
const Cateringmissionvission = () => {
    const [mission, setMission] = useState("");
    const [visionDesc, setVisionDesc] = useState("");
    const [vendorId, setVendorId] = useState(null);
    const [aboutUsId, setAboutUsId] = useState(null);
    const [isEditing, setIsEditing] = useState(false);

    // Get vendorId from localStorage
    useEffect(() => {
        const storedVendorId = localStorage.getItem("vendorId");
        setVendorId(storedVendorId);
    }, []);

    // Fetch existing data
    useEffect(() => {
        if (vendorId) fetchAboutUsData(vendorId);
    }, [vendorId]);

    const fetchAboutUsData = async (vendorId) => {
        const token = localStorage.getItem("authToken");
        if (!token) return;

        try {
            const res = await axios.get(
                `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/aboutus/${vendorId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            const data = res.data;
            setAboutUsId(data?.aboutUsId || null);
            setMission(data?.mission || "");
            setVisionDesc(data?.vision || "");
        } catch (err) {
            console.error("Fetch Error:", err.response?.data || err.message);
        }
    };

    // Send data (both POST and PUT) like About Us format
    const sendMissionVision = async (method) => {
        if (!vendorId) return alert("Vendor ID missing!");
        if (!mission.trim() || !visionDesc.trim()) return alert("Fields cannot be empty!");

        const token = localStorage.getItem("authToken");
        if (!token) return alert("Authorization token missing");

        const aboutUsData = { mission, vision: visionDesc };
        const formData = new FormData();
        formData.append("aboutUsData", new Blob([JSON.stringify(aboutUsData)], { type: "application/json" }));

        const url =
            method === "POST"
                ? `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/vendor/aboutus/add/${vendorId}`
                : `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/vendor/aboutus/update/${aboutUsId}`;

        try {
            const res = await fetch(url, {
                method,
                headers: { Authorization: `Bearer ${token}` },
                body: formData,
            });

            if (res.ok) {
                alert(method === "POST" ? "Mission & Vision added!" : "Mission & Vision updated!");
                fetchAboutUsData(vendorId);
                setIsEditing(false);
            } else {
                const err = await res.json();
                alert(`Failed: ${err.message || "Unknown error"}`);
            }
        } catch (err) {
            console.error("Submit Error:", err);
            alert("Something went wrong. Please try again.");
        }
    };

    return (
        <section style={containerStyle}>
            <div style={{ justifyContent: "center", gap: "20px" }} className="card-data-contnetcode">
                <h1 style={sectionTitleStyle}>OUR COMMITMENTS</h1>
                <div style={{ textAlign: "center", marginTop: "20px" }} className="card-data-contnetcode">
                    <button onClick={() => sendMissionVision("POST")} style={buttonStyle}>Add +</button>
                    <button
                        onClick={() => {
                            if (isEditing) sendMissionVision("PUT");
                            else setIsEditing(true);
                        }}
                        style={{ ...buttonStyle, marginLeft: "10px" }}
                    >
                        {isEditing ? <FaSave /> : <FaEdit />}
                    </button>
                </div>
            </div>

            <div style={cardWrapperStyle} className="mission-vission-card-wrapper">
                <Card image={misionn} title="Our Mission" value={mission} onChange={setMission} />
                <Card image={vision} title="Our Vision" value={visionDesc} onChange={setVisionDesc} />
            </div>
        </section>
    );
};

const buttonStyle = {
    backgroundColor: "#b15dc6",
    color: "#fff",
    fontSize: "14px",
    padding: "10px 15px",
    borderRadius: "6px",
    border: "none",
    cursor: "pointer",
};

export default Cateringmissionvission;
